var cachedVariablesJson = require("./cachedVariables.json");
var cachedVariables = cachedVariablesJson || {};
module.exports = cachedVariables;